import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyHome: BaseKeyFunction = () => ["home"];
